import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { State } from '@progress/kendo-data-query';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useDebounce } from '@uidotdev/usehooks';

import { apiClient } from 'core/api/globals';

import { AuthenticationScheme, useAssertFetchPermitted } from 'features/auth';

/**
 * Hook for fetching paged upload tracker data using React Query.
 * @param dataState The Kendo data state for pagination, sorting, and filtering.
 * @param debounce Whether to debounce the data state changes before making the query.
 * @returns Query result for the paged data.
 */
export function useQueryUploadTrackerGrid(dataState: State | null, debounce: boolean) {
  const activeScheme = useAssertFetchPermitted([AuthenticationScheme.OIDC]);

  const debouncedDataState = useDebounce(dataState, debounce ? 500 : 0);

  const uploadTrackerQuery = useQuery({
    queryKey: ['upload-tracker-grid', debouncedDataState == null ? debouncedDataState : toDataSourceRequestString(debouncedDataState)],
    queryFn: debouncedDataState == null || activeScheme == null ? skipToken : () => apiClient.uploadTrackerClient.getAllForKendoGrid(debouncedDataState),
    staleTime: 1000 * 60, // 1 minute cache
    placeholderData: (previousData) => previousData, // Keep previous data as placeholder when query key changes
  });

  return uploadTrackerQuery;
}
